export const ContentFieldType = {
  TEXT: "text",
  TEXT_AREA: "textarea",
  RICH_TEXT: "rich_text",
  SELECT: "select",
  SWITCH: "switch",
  NUMBER: "number",
  DATE: "date",
  TIME: "time",
  DATETIME: "datetime",
  IMAGE: "image",
  GALLERY: "gallery",
  MEDIA: "media",
  UNIT_ID: "unit_id",
  BRAND_ID: "brand_id",
  PRICE: "price",
  ARRAY_STRING: "array_string",
  DROPDOWN: "dropdown",
  COLORS: "colors",
  SITE_STATUS: "site_status",
  CODE_EMBED: "code_embed",
  INSTALLMENTS: "installments",
  SUBSCRIPTION_PLANS: "subscription_plans",
  SUBSCRIPTION_COUPONS: "subscription_coupons",
  SUBSCRIPTION_OPTIONALS: "subscription_optionals",
  COLOR_SURCHARGES: "color_surcharges",
  TAGS: "tags",
  REPEATER: "repeater",
} as const;

export type ContentFieldTypeValue =
  (typeof ContentFieldType)[keyof typeof ContentFieldType];

export type ContentFieldTypeArray = readonly ContentFieldTypeValue[];

export const contentFieldTypeEnum = Object.values(
  ContentFieldType,
) as readonly ContentFieldTypeValue[];

export const contentFieldTypeGroups = {
  string: [
    ContentFieldType.TEXT,
    ContentFieldType.TEXT_AREA,
    ContentFieldType.RICH_TEXT,
    ContentFieldType.SELECT,
    ContentFieldType.DROPDOWN,
    ContentFieldType.UNIT_ID,
    ContentFieldType.BRAND_ID,
  ],
  number: [ContentFieldType.NUMBER, ContentFieldType.PRICE],
  boolean: [ContentFieldType.SWITCH],
  date: [
    ContentFieldType.DATE,
    ContentFieldType.TIME,
    ContentFieldType.DATETIME,
  ],
  image: [ContentFieldType.IMAGE],
  gallery: [ContentFieldType.GALLERY],
  media: [ContentFieldType.MEDIA],
  array: [ContentFieldType.ARRAY_STRING],
  colors: [ContentFieldType.COLORS],
  code: [ContentFieldType.CODE_EMBED],
  composite: [ContentFieldType.INSTALLMENTS, ContentFieldType.REPEATER],
  plans: [ContentFieldType.SUBSCRIPTION_PLANS],
  tags: [ContentFieldType.TAGS],
} as const satisfies Record<string, ContentFieldTypeArray>;

export type PrimitiveType = keyof typeof contentFieldTypeGroups;

export const contentFieldTypeFiltersGroups = {
  filterable: [
    ContentFieldType.TEXT,
    ContentFieldType.SELECT,
    ContentFieldType.DROPDOWN,
    ContentFieldType.NUMBER,
    ContentFieldType.DATE,
    ContentFieldType.TIME,
    ContentFieldType.DATETIME,
    ContentFieldType.SWITCH,
    ContentFieldType.UNIT_ID,
    ContentFieldType.PRICE,
    ContentFieldType.BRAND_ID,
  ],
  globalFilter: [ContentFieldType.UNIT_ID],
  searchable: [
    ContentFieldType.TEXT,
    ContentFieldType.TEXT_AREA,
    ContentFieldType.RICH_TEXT,
  ],
} as const satisfies Record<string, ContentFieldTypeArray>;

export type FilterTypeGroup = keyof typeof contentFieldTypeFiltersGroups;
